import { render } from "./LoadingLayout.vue?vue&type=template&id=3a4233b6"
import script from "./LoadingLayout.vue?vue&type=script&lang=ts"
export * from "./LoadingLayout.vue?vue&type=script&lang=ts"
script.render = render

export default script